import { Link } from 'react-router';
import { useUsable } from '../../../data/hooks';
import { listTiles } from '../../../data/repos/tiles';
import { useQuery } from '../../../data/useQuery';
import { BentoGrid } from '../../../tiles/BentoGrid';
import { visibleTiles } from '../../../tiles/layout';
import { MenuCard } from '../../../ui';
import { copy } from '../copy';
import { SPENDING_DASHBOARD_ID } from '../dashboardDefaults';
import { useEntryCount, useUncategorized } from '../hooks';
import { ACCENT_LINK, H1, SCREEN } from '../styles';

export function SpendingDashboard() {
  const count = useEntryCount();
  const uncategorized = useUncategorized() ?? [];
  const usable = useUsable();
  const { data: rows } = useQuery(['tiles'], (db) => listTiles(db, SPENDING_DASHBOARD_ID));
  const tiles = visibleTiles(rows ?? [], usable, { includeHidden: false });
  return (
    <main className={SCREEN}>
      <header className="flex items-center justify-between gap-3">
        <h1 className={H1}>{copy.moduleName}</h1>
        <Link to="/m/spending/add" className={ACCENT_LINK}>
          {copy.add}
        </Link>
      </header>
      {count === 0 ? <p className="text-muted">{copy.empty}</p> : null}
      <BentoGrid tiles={tiles} label={copy.moduleName} />
      <MenuCard
        label={copy.pages}
        items={[
          {
            to: '/m/spending/entries',
            label: copy.entriesTitle,
            icon: 'list',
            value: count ? copy.entryCount(count) : null,
          },
          { to: '/m/spending/breakdown', label: copy.breakdownTitle, icon: 'bars' },
          { to: '/m/spending/categories', label: copy.categoriesTitle, icon: 'tag' },
          uncategorized.length > 0 && {
            to: '/m/spending/tidy',
            label: copy.tidyTitle,
            icon: 'sparkle',
            value: copy.toSort(uncategorized.length),
          },
        ]}
      />
    </main>
  );
}
